import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { LangService } from 'src/app/Services/lang.service';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalConstants } from '../global-constans';
declare var $: any;
import { zendeskChangeLanguage } from 'src/app/Services/zendesk.service';
import { UserService } from '../../Services/user.service';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { CustomUrlSerializer } from "../../shared/models/UrlSerializer/custom-url-serializer";

@Component({
  selector: 'app-auth-header',
  templateUrl: './auth-header.component.html',
  styleUrls: ['./auth-header.component.scss']
})
export class AuthHeaderComponent implements OnInit, OnDestroy {
  url: any = '';
  menuActive: any = false;
  currentLang: any = '';
  unsubscribe$: Subject<void> = new Subject<void>();
  languages: any = [];
  public imgUrl: any = environment.imgUrl;
  landingPageUrl: any = environment.landingPageUrl;
  constructor(
    private router: Router,
    private lang: LangService,
    private translate: TranslateService,
    private userService: UserService,
    private cookieService: CookieService
  ) {

    this.router.events.pipe(takeUntil(this.unsubscribe$)).subscribe((val) => {
      // see also
      if (val instanceof NavigationEnd) {
        this.url = CustomUrlSerializer.decript(val.url).replace('/', '') || 'subscribe';
      }
    });
  }
  changeLanguageLocal(lang) {
    this.cookieService.set('OBSIDIAM-LOCALE', lang, new Date(new Date().getTime() + environment.cookieExpireTime), '/', window.location.hostname, true, 'Strict');
    GlobalConstants.language = lang;
    zendeskChangeLanguage(lang);
    this.currentLang = lang;
    if (!environment.production)
      console.log('Auth-header', lang)
    this.translate.setDefaultLang(lang.toLocaleLowerCase());
    this.translate.use(lang.toLocaleLowerCase())

    this.translate.get('header.languages').pipe(takeUntil(this.unsubscribe$)).subscribe((langs: any) => {
      this.languages = langs;

    });
    this.userService.changeLanguageEmit(lang, false);
    setTimeout(() => {
      this.translate.setDefaultLang(lang.toLocaleLowerCase());
      this.translate.use(lang.toLocaleLowerCase())
      // this.userService.changeLanguageEmit(lang, false);
    }, 1000);

  }
  ngOnInit() {

    $(document).ready(() => {
      $(window).scroll(() => {
        if (this.menuActive) {
          $('#navbar-button').click();
        }
      });
    });

    if (sessionStorage.getItem('cookies')) {
      localStorage.setItem('cookies', sessionStorage.getItem('cookies'));
    } else {
      localStorage.setItem('cookies', localStorage.getItem('cookies'));
    }
    localStorage.setItem('takeFeeOff', sessionStorage.getItem('takeFeeOff'));
    localStorage.setItem('rememberLate', sessionStorage.getItem('rememberLate'));

    let lang = this.translate.getDefaultLang()
    this.currentLang = this.translate.currentLang || lang || 'en';
    this.changeLanguageLocal(this.currentLang);
    $('.switch input').click(() => {
      if ($('.switch input').is(':checked')) {
        $('.bgcolor').addClass('nightmode');
        $('.header').addClass('fixedblack');
        $('.whiteback').css('background-color', 'transparent');
        $('.textcolor').addClass('whitetext');
        $('.switch i').text('Night');
        $('.formstyle .select_region').addClass('darkselect');
        $('.selectBx i').css('color', '#fff');
        $('.code_div .form-control').css('color', '#fff');
        $('.modal-content').css('background-color', '#000');
      } else {
        $('.bgcolor').removeClass('nightmode');
        $('.header').removeClass('fixedblack');
        $('.whiteback').css('background-color', '#fff');
        $('.textcolor').removeClass('whitetext');
        $('.switch i').text('Day');
        $('.formstyle .select_region').removeClass('darkselect');
        $('.selectBx i').css('color', '#000');
        $('.code_div .form-control').css('color', '#98a9bc');
        $('.modal-content').css('background-color', '#fff');
      }
    });

  }
  menuEvent($this) {
    this.menuActive = !this.menuActive;
    if (!$($this).hasClass('is-active')) {
      $('#mySidenav').css({ left: '0px', width: '185px' });
      $('.logohome a img').attr('src', 'https://cdn-dev.obsidiam.com/img/obsidiam_welcome.png');
    } else {
      $('#mySidenav').css('left', '-250px');
      $('.logohome a img').attr('src', './assets/images/obsidiam_logo_blanco.png');
    }
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  goToLandingPage() {
    window.open(environment.landingPageUrl, '_self');
  }
}
